import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

export const searchScores = async (query) => {
  const queryString = new URLSearchParams(query)

  const response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/scores/breakdown?${queryString}`)
  return { scores: response.data.items, total: response.data.total }
}

export const postQuartiles = async (payload) => {
  let response = await axios.post(`${servers[store.state.auth.server].scores}/api/v1/quartiles/upload`, payload.file.data)
  return response
}

export const postAligns = async (payload) => {
  let response = await axios.post(`${servers[store.state.auth.server].scores}/api/v1/quartiles/aligns/upload`, payload.file.data)
  return response
}

export const getQuartiles = async (data) => {
  const queryString = new URLSearchParams(data)
  let quartiles = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/quartiles?${queryString}`)
  return quartiles.data
}

export const getScoreGroups = async () => {
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/score-groups`)
  return response.data.items
}

export const getScoringModels = async (data) => {
  const queryString = new URLSearchParams(data)
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/models?${queryString}`)
  return response.data.models
}

export const postScoringModel = async (data) => {
  delete data[0]['id']
  let response = await axios.post(`${servers[store.state.auth.server].scores}/api/v1/models`, data)

  return response.data
}

export const putScoringModel = async (data) => {
  let response = await axios.put(`${servers[store.state.auth.server].scores}/api/v1/models?id=${data['id']}`, data)
  return response.data.model
}

export default {
  searchScores,
  postQuartiles,
  getQuartiles,
  getScoreGroups,
  getScoringModels,
  postScoringModel,
  postAligns,
  putScoringModel
}
